import { useMutation } from '@apollo/client'
import { addStudentEnrollmentMutation } from '../../../appsync/graphql/student'
import { updateStudentEnrollments } from '../../../appsync/actions/student'
import { updateStudentHasEnrollments } from '../../../appsync/actions/settings'
import { formatAppsyncErrors } from '../../../appsync/utils'

const useStudentAddEnrollmentMutation = ({ educationPeriod, input, onError }) => {
  const [mutate, { data: rawData = {}, called, loading, error: rawError = null, client }] =
    useMutation(addStudentEnrollmentMutation, {
      variables: { code: educationPeriod, input },
      onCompleted: () => updateStudentHasEnrollments(client),
      onError,
      update(cache, { data }) {
        // updateStudentEnrollments expects data to be a property in the object
        updateStudentEnrollments({
          cache,
          response: { data },
          key: 'addStudentEnrollment',
          educationPeriod,
        })
      },
    })

  const data = rawData?.addStudentEnrollment ?? {}
  const error = rawError ? formatAppsyncErrors(rawError) : null

  return { mutate, data, called, loading, error }
}

export default useStudentAddEnrollmentMutation
